import { render, staticRenderFns } from "./BaseDropmenu.vue?vue&type=template&id=f1ef1852&scoped=true"
import script from "./BaseDropmenu.vue?vue&type=script&lang=js"
export * from "./BaseDropmenu.vue?vue&type=script&lang=js"
import style0 from "./BaseDropmenu.vue?vue&type=style&index=0&id=f1ef1852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ef1852",
  null
  
)

export default component.exports